import React from 'react';

import './index.sp.scss';
import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpInputItem from 'components/molecules/SpInputItem';
import SpInputTitle from 'components/molecules/SpInputTitle';
import SpAccordionTextArea from 'components/molecules/SpAccordionTextArea';
import SpStepProgressBar from 'components/molecules/SpStepProgressBar';
import SpModalBack from 'components/molecules/PcModalBack';
import SpPointComment from 'components/molecules/SpPointComment';
import SpInputHourSalary from 'components/molecules/SpInputHourSalary';

import { POINT_COMMENT_MAP } from 'utils/constant';

const PresentSP = ({
  // 表示リスト
  DispList1,
  DispList2,
  workingDayRangeOthersDisp,
  attendanceDisp,
  hourSalaryDisp,

  // onChange
  modalBackIsEnable,

  // onClick
  onClickMainButton,

  // 入力チェック
  valid,
  errorDispMap,
  isApiError,
  showLoading,

}) => (
  <div className="AddCondition SP">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      showLoading={showLoading}
    >
      <SpStepProgressBar currentStep='5' />
      <div id="addCondition" className="contents">
        <div className="titleArea">
          <p className="title">就業条件</p>
        </div>
        <div id="dispList1" className="dispList1">
          {DispList1.map((data) => {
            return (
              <span key={data.title}>
                <SpInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </SpInputItem>
              </span>
            );
          })}
        </div>
        <SpPointComment labelList={POINT_COMMENT_MAP.workTimePointCmnt.labelList} pattern={POINT_COMMENT_MAP.workTimePointCmnt.pattern} />
        <div id="dispList2" className="dispList2">
          {DispList2.map((data) => {
            return (
              <span key={data.title}>
                <SpInputItem
                  title={data.title}
                  subTitle={data.subTitle}
                  label={data.label}
                  questionMark={data.questionMark}
                  popUpTitle={data.popUpTitle}
                  popUpDetail={data.popUpDetail}
                >
                  {data.input}
                </SpInputItem>
              </span>
            );
          })}
        </div>
        <div className="workingDayRangeOthersDisp">
          <SpAccordionTextArea
            value={workingDayRangeOthersDisp.value}
            label={workingDayRangeOthersDisp.label}
            checkBoxOnChange={workingDayRangeOthersDisp.onChange}
            checked={workingDayRangeOthersDisp.checked}
            id={workingDayRangeOthersDisp.id}
            textAreaTitle={workingDayRangeOthersDisp.comment.title}
            textAreaLabel={workingDayRangeOthersDisp.comment.label}
            name={workingDayRangeOthersDisp.comment.name}
            textAreaValue={workingDayRangeOthersDisp.comment.textAreaValue}
            cmntOnChange={workingDayRangeOthersDisp.comment.cmntOnChange}
            onInput={workingDayRangeOthersDisp.comment.onInput}
            onCompositionEnd={workingDayRangeOthersDisp.comment.onCompositionEnd}
            maxLength={workingDayRangeOthersDisp.comment.maxLength}
            placeholder={workingDayRangeOthersDisp.comment.placeholder}
            rows={workingDayRangeOthersDisp.comment.rows}
            cols={workingDayRangeOthersDisp.comment.cols}
            wordCount={workingDayRangeOthersDisp.comment.wordCount}
            inValid={workingDayRangeOthersDisp.comment.inValid}
            errPosition={workingDayRangeOthersDisp.comment.errPosition}
            errMessage={workingDayRangeOthersDisp.comment.errMessage}
          />
        </div>
        <div className="attendanceDisp">
          <SpInputTitle
            title={attendanceDisp.title}
            label={attendanceDisp.label}
            list={attendanceDisp.list}
            type={attendanceDisp.type}
            childInput={attendanceDisp.childInput}
          />
        </div>
        <div className='hourSalaryDisp'>
          <SpInputItem
            title={hourSalaryDisp.title}
            subtitle={hourSalaryDisp.subtitle}
            label={hourSalaryDisp.label}
            questionMark={hourSalaryDisp.questionMark}
            popUpTitle={hourSalaryDisp.popUpTitle}
            popUpDetail={hourSalaryDisp.popUpDetail}
          >
            <>
              <div className='hourSalary'>
                <SpInputHourSalary
                  hourSalaryMin={hourSalaryDisp.input.hourSalaryMin}
                  value={hourSalaryDisp.input.hourSalaryMax}
                  onChange={hourSalaryDisp.input.onChangeHourSalaryMax}
                  onInput={hourSalaryDisp.input.onChangeHourSalaryMax}
                  onCompositionEnd={hourSalaryDisp.input.onChangeHourSalaryMax}
                  maxLength='4'
                  placeholder={hourSalaryDisp.input.placeholder}
                  inValid={hourSalaryDisp.input.inValid}
                  errMessage={errorDispMap.hourSalaryMax}
                  apiErrMessage={hourSalaryDisp.input.apiErrMessage}
                />
              </div>
            </>
          </SpInputItem>
        </div>
      </div>
      <SpModalBack modalBackIsEnable={modalBackIsEnable} />
    </SpBasicTemplate>
  </div>
);

export default PresentSP;